
import { defineComponent } from 'vue';
import FontApp from './components/FontApp.vue';
import store from './store';

export default defineComponent({
    name: 'App',
    components: {
        FontApp,
    },
    store,
});

import '@/assets/css/tailwind.css';
